import guide from './monitor_customer_help.json';

export const MONITOR_HELP_VERSION=guide.content_version;
export const MONITOR_HELP_CONTENT=Object.fromEntries(['page_title','quick_guide','key_metrics','tip'].map(key=>[key,guide[key]]));
export const MONITOR_HELP_TIPS=guide.tips_and_tricks;
